export default {
  search: 'Search',
  iconclass: 'ICONCLASS',
  explore: 'Explore',
  vise: 'Vise',
  exhibitions: 'Exhibitions',
  project: 'Project',
  team_and_partners: 'Team & Partners',
  contact: 'Contact',
  help: 'Help',
  help_link: 'https://e-ilustrace.cz/en/help/',
  close: 'Close',
  login: 'Log in',
  login_page: 'Log in',
  registration: 'Registration',
  register: 'Register',
  email: 'E-mail address',
  recovery_email: 'Enter an email address',
  recovery_email_sent: 'Password reset email has been successfully sent',
  password_change: 'Password change',
  old_password: 'Old password',
  new_password: 'New password',
  do_password_change: 'Change password',
  password_reset: 'Password change',
  password_changed: 'Password changed successfully',
  password: 'Password',
  repeated_password: 'Repeated password',
  name: 'Name',
  surname: 'Surname',
  remember_login: 'Remember login',
  forgot_password: 'Did you forget the password?',
  accept_terms: 'I agree with the',
  accept_terms_link_name: ' terms and conditions',
  accept_terms_link: 'https://e-ilustrace.cz/en/terms-of-registration/',
  password_recovery: 'Password recovery',
  recovery_link: 'Email me a recovery link',
  recovered: 'Recovered',
  recovered_text:
    'If account exists, an email will be sent with further instructions',
  field_is_required: 'Fill up this field please',
  bad_email_format: 'Bad email format',
  accepted_terms_required: 'Accept terms to proceed registration',
  bad_repeated_password: 'Passwords does not match',
  registration_successful:
    'Registration was successful, now please confirm your email',
  registration_activation_successful:
    'Your account has been successfully activated, you can now log in',
  status_logged_in: 'Logged in',
  status_logged_out: 'Logged out',
  status_checking: 'Checking',
  citations_info: 'Citation rules',
  citations_title: 'Citation Rules',
  citations_intro:
    'By entering the e-ilustrace database, the user undertakes to reference its use in all outputs.',
  citations_recommendation:
    'When citing, we recommend using the source in the following form:',
  citations_database_reference:
    'e-ilustrace.cz [online database]. Prague: Library of the Czech Academy of Sciences, [cit. yyyy-mm-dd]. Available from: https://e-ilustrace.cz/.',
  citations_specific_record_title: 'Specific record in the database:',
  citations_specific_reference:
    'e-ilustrace.cz [online database], INC035_IL010. [cit. yyyy-mm-dd]. Available from: https://app.e-ilustrace.cz/record-detail/2c44d885-1408-47e5-8cac-768e01b3720e/switch?back=search.',
  citations_note:
    'Note: If you cite a different record, replace the record number and URL with the corresponding values from that record.',
  citations_accept: 'I agree',
}
